export const globalLightTheme = {
  '--global-bgc-1': 'rgba(159, 167, 179, 0.13)',
  '--global-font-c-1': '#333',
  '--global-font-c-2': '#f8f8f8',
  '--global-font-c-3': '#333',
  '--global-font-c-4': '#41cc8b',
  '--global-shadow-c-1': 'rgba(33, 35, 43, 0.48)',
  '--global-border-c-1': '#eee',
  '--global-border-c-2': '#eee',
}
export const globalDarkTheme = {
  '--global-bgc-1': 'rgba(159, 167, 179, 0.13)',
  '--global-font-c-1': '#fff',
  '--global-font-c-2': '#2b2e38',
  '--global-font-c-3': '#fff',
  '--global-font-c-4': '#41cc8b',
  '--global-shadow-c-1': 'rgba(33, 35, 43, 0.48)',
  '--global-border-c-1': '#393c47',
  '--global-border-c-2': '#3b3e49',
}
